import Header from '../components/header';
import { withDeepLink } from './HybirdContext.container';

export default withDeepLink(Header);
